import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import TermsConditionsContent from '../Components/Policy/TermsConditionsContent'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'

function TermsConditions() {
    return (
        <>
            <HeaderOne />
            <Breadcrumb title="Terms & Conditions" />
            <TermsConditionsContent />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default TermsConditions